import React, { useState, useEffect, useRef, useCallback } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import Dictaphone from "components/Question/Speaking/Dictaphone.jsx";
import Sound from 'react-sound';
import { base, s3base } from "api.js";
import ReusableRecorder from "components/Recorder/ReusableRecorder";
import "components/custom.css";
import NoMicrophone from "views/NoMicrophone";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";
import MicWaveform from 'components/Question/Speaking/MicWaveform';
import { formatTimeMiliSecond } from "util/helper.js";
import { isIOSDevice } from "util/deviceDetection";
import useBeep from 'components/BeepSound';
import IOSAudioPlayer from "components/Question/Speaking/New/IOSAudioPlayer.jsx";
import Beep from "Beep.js";

const ShortQue = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(3);
  const [secondCount2, setSecondCount2] = useState(1);
  const [duration, setDuration] = useState(0);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [trans, setTrans] = useState('');
  const [correctFlag, setCorrectFlag] = useState(true);
  const [beepStatus, setBeepStatus] = useState(false);
  const [file, setFile] = useState('');
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [secondCount2Bckup, setSecondCount2Bckup] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [intervalId2, setIntervalId2] = useState(0);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(10);
  const [recordingProgress, setRecordingProgress] = useState(0);
  const [recordingStartTime, setRecordingStartTime] = useState(0);

  const recorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);
  const beepPlayedRef = useRef(false);
  const submittedRef = useRef(false); // Prevent multiple submissions
  const handleRecordingCompleteRef = useRef(null);
  const { playBeep } = useBeep({ frequency: 800, duration: 300, volume: 0.3 });

  // Component Did Mount
  useEffect(() => {
    if (!props.answer) {
      let question_audio = null;
      let defaultSelectedVoice = null;

      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoice = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoice);
    }

    if (!props.resultMode) {
      navigator.mediaDevices.getUserMedia({ audio: true },
        () => {
          setIsBlocked(false);
        }, () => {
          setIsBlocked(true);
        },
      );
    } else {
      setIsBlocked(false);
    }

    return () => {
      clearInterval(intervalId);
      if (recordingIntervalRef.current) {
        clearInterval(recordingIntervalRef.current);
      }
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalId);
        clearInterval(recordId);
        if (recordingIntervalRef.current) {
          clearInterval(recordingIntervalRef.current);
        }

        let question_audio = null;
        let defaultSelectedVoice = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoice = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setIsRecording(false);
        setSecondCount(3);
        setSecondCount2(1);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setTrans('');
        setSoundStatus(true);
        setDuration(0);
        setQuestionAudio(question_audio);
        setDefaultSelectedVoice(defaultSelectedVoice);

        // UPDATED: Reset to 10 seconds for Short Answer
        setRecordingTimeLeft(10);
        setRecordingProgress(0);
        beepPlayedRef.current = false;
        submittedRef.current = false; // Reset submission flag
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart]);

  // Handle reset
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setReset(false);
      // UPDATED: Reset to 10 seconds for Short Answer
      setRecordingTimeLeft(10);
      setRecordingProgress(0);
      beepPlayedRef.current = false;
    }
  }, [reset]);

  // Start recording immediately — called the moment the beep begins playing
  const startRecordingNow = useCallback(() => {
    if (isBlocked) return;

    if (recorderRef.current) {
      recorderRef.current.startRecording();
    }

    setIsRecording(true);
    setBlobURL('');

    // UPDATED: Start recording timer and progress for 10 seconds
    const startTime = Date.now();
    setRecordingStartTime(startTime);
    setRecordingTimeLeft(10);
    setRecordingProgress(0);

    // Clear any previous interval
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
    }

    // UPDATED: Update recording progress and timer every 100ms for 10 seconds
    recordingIntervalRef.current = setInterval(() => {
      const elapsed = (Date.now() - startTime) / 1000;
      const timeLeft = Math.max(0, 10 - elapsed); // CHANGED: 10 seconds total
      const progress = Math.min(100, (elapsed / 10) * 100); // CHANGED: 10 seconds total

      setRecordingTimeLeft(Math.ceil(timeLeft));
      setRecordingProgress(progress);

      if (elapsed >= 10 + 1) {
        clearInterval(recordingIntervalRef.current);
        recordingIntervalRef.current = null;
        if (recorderRef.current) {
          recorderRef.current.stopRecording();
        }
      }
    }, 100);
  }, [isBlocked]);

  // Start recording with beep control
  const startRecording = () => {
    if (!beepPlayedRef.current) {
      beepPlayedRef.current = true;
      // Start recording immediately when beep begins so no audio is missed
      startRecordingNow();
      setBeepStatus(true);
    }
  };

  // Recording already started when beep began — just clear beep status
  const handleBeepFinishedPlaying = () => {
    setBeepStatus(false);
  };

  const handlePlayBeep = useCallback(() => {
    playBeep({
      onStart: () => {
        setBeepStatus(true);
        // Start recording immediately when beep begins so no audio is missed
        startRecordingNow();
      },
      onComplete: () => {
        setBeepStatus(false);
      },
      onError: (error) => {
        console.error('Beep failed:', error);
        setBeepStatus(false);
      }
    });
  }, [playBeep, startRecordingNow]);

  useEffect(() => {
    if (isIOSDevice() && beepStatus) {
      handlePlayBeep();
    }
  }, [beepStatus, playBeep, isIOSDevice]);

  const updateCorrect = () => {
    props.submit({ 'data': '' });
    setCorrectFlag(false);
  };

  const handleSongPlaying = (obj) => {
    const remainingMs = obj.duration - obj.position;
    setSoundPer(obj.position * 100 / obj.duration);
    setRemainingTime(formatTimeMiliSecond(remainingMs));
  };

  const skip = () => {
    clearInterval(intervalId);
    setSecondCount(0);
  };

  const setTransHandler = (a) => {
    if (trans !== a) {
      setTrans(a);
    }
  };

  const handleRecordingComplete = (recordingData) => {
    const { blob, url, transcript, duration: recordDuration, file } = recordingData;
    
    setBlobURL(url);
    setIsRecording(false);
    setFile(file);
    setRecordingProgress(100);
    setTrans(transcript || trans);

    if (isIOSDevice() && !submittedRef.current) return;

    const dataToSubmit = {
      data: file,
      audio_text: transcript || trans,
      duration: recordDuration
    };

    if (props.testMode) {
      props.nextQuestion(dataToSubmit);
    } else {
      props.submit(dataToSubmit, true);
      props.showResult();
    }
  };

  // Stop recording with cleanup
  const stopRecording = () => {
    if (!isBlocked && isRecording && recorderRef.current) {
      // Clear the recording interval
      if (recordingIntervalRef.current) {
        clearInterval(recordingIntervalRef.current);
        recordingIntervalRef.current = null;
      }
      recorderRef.current.stopRecording();
    }
  };

  // Stop test with cleanup
  const stopTest = async () => {
    if (submittedRef.current) return; // Prevent multiple calls
    submittedRef.current = true;
    
    console.log('stopTest called, isRecording:', isRecording);
    
    if (!isBlocked && isRecording && recorderRef.current) {
      // Clear the recording interval
      if (recordingIntervalRef.current) {
        clearInterval(recordingIntervalRef.current);
        recordingIntervalRef.current = null;
      }

      setIsRecording(false);
      setRecordingProgress(100);
      recorderRef.current.stopRecording();
    } else {
      console.log('Calling nextQuestion with existing data');
      props.nextQuestion({
        data: file,
        audio_text: trans,
        duration: duration
      });
    }
  };

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount === 0) {
        clearInterval(intervalId);
        return 0;
      } else {
        return prevCount - 1;
      }
    });
  };

  const timer1 = () => {
    setSecondCount2(prevCount => {
      if (prevCount === 0) {
        clearInterval(intervalId);
        startRecording(); // Start recording with new system only
        setSoundStatus(false);
        return 0;
      } else {
        if (secondCount2Bckup === 0) {
          setSecondCount2Bckup(prevCount);
        }
        return prevCount - 1;
      }
    });
  };

  const handleSongFinishedPlaying = () => {
    const newIntervalId = setInterval(timer1, 1000);
    setSoundStatus(false);
    setIntervalId(newIntervalId);
    props.soundChecked();
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  // REMOVED: Old timerRecord - now using recordingIntervalRef for timing

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
    setSecondCount2(secondCount2Bckup);
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId2);

    setIntervalId2(0);

    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestionAudio(`${s3base}/${selected_audio[0].value}`);
  };

  if (isBlocked) {
    return (<NoMicrophone />);
  }

  // if (props.stopRecording) {
  //   stopTest();
  // }

   useEffect(()=>{
    if (props.stopRecording) {
      stopTest();
    }
    },[props.stopRecording])

  let questionText = "";
  if (props.restart) {
    props.restartQue();
  }
    
  useEffect(() => {
    if (props.data && correctFlag) {
      updateCorrect();
    }
  }, [props.data, correctFlag]);

  // if (props.data) {
  //   questionText = props.data.question;
  //   if (correctFlag) {
  //     updateCorrect();
  //   }
  // }
  handleRecordingCompleteRef.current = handleRecordingComplete;
      
  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []);

  return (
    <>
      <ReusableRecorder
        ref={recorderRef}
        onRecordingComplete={stableHandleRecordingComplete}
        maxDuration={10000}
        enableSpeechRecognition={true}
        fileName={"noname5.mp3"}
      />
      {/* <Dictaphone setTrans={setTransHandler} status={reset || isRecording} /> */}
      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>
      <Col xs={12}>
        <div className="col-lg-12 p-0 text-center">
          {!props.resultMode && <div>
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              <div className="w-100 text-white p-4" >
                <br></br>
                <div className="d-flex justify-content-end w-100 align-items-center min-height-player-text">
                {(secondCount === 0 && blobURL === '' && !isRecording) &&
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  }
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3" >
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barStyle={{ backgroundColor: "#4493e0" }} now={(soundPer)} />
                  </div>
                </div>
                <div className="d-flex justify-content-start w-100 align-items-center min-height-player-text" >
                  {soundPer === 100 ? (
                    <p className="mb-0 fs-10 mx-4">Completed</p>
                  ) : soundStatus === true &&
                    secondCount !== 0 &&
                    !isRecording ? (
                    <p className="mb-0 fs-10 mx-4">
                      The clip will begin in {secondCount} seconds
                    </p>
                  ) : (
                    <p className="mb-0 fs-10 mx-4 invisible"></p>
                  )}
                </div>
                {!props.testMode && (
                  <div className="d-flex justify-content-between">
                    <div className='stop-btn'>
                      {!props.testMode && secondCount !== 0 && blobURL === '' && !isRecording &&
                        <Button variant="success" onClick={skip} size="sm">Skip</Button>
                      }
                    </div>
                    <div className="stop-btn clearfix">
                      <div className="select-voice pull-left">
                        {defaultSelectedVoice !== null &&
                          <SelectVoiceDropDown
                            voices={props.voices}
                            selected={defaultSelectedVoice}
                            changeAudio={changeAudio}
                          />
                        }
                      </div>
                      <div className="select-speed pull-right">
                        <PlaybackSpeedBtns changePlaybackSpeed={changePlaybackSpeed} playbackSpeed={playbackSpeed} />
                      </div>
                    </div>
                  </div>
                )}
                <br ></br>
                <div className="w-100 d-flex justify-content-center align-items-center" >
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50" >
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" />
                  </div>
                </div>

              </div>
            </div>
            <div className="audio-box border-0 position-sticky mock-resource-text">
              <p className="px-5 mx-2 text-secondary pb-0 mb-0"> {blobURL === '' && isRecording ? "Recording" : ""} </p>
              <hr></hr>
              {!props.testMode && isRecording && (
                <div className='stop-btn'>
                  <Button variant="success" onClick={stopRecording} size="sm">Stop</Button>
                </div>
              )}
              <hr></hr>
              <div
                className="d-flex justify-content-start align-items-center gap-3"
                style={{ minHeight: "60px" }}
              >
                {isRecording ? (
                  <img
                    src={stopImage}
                    alt="Stop Recording"
                    style={{
                      height: "65px",
                      width: "65px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={grayImage}
                      alt="Not Recording"
                      style={{
                        height: "65px",
                        width: "65px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                    <p className="text-center p-0 m-0" style={{ fontSize: "20px" }}>Ready in {secondCount2}</p>
                  </div>
                )}

                <div
                  className="d-flex align-items-center justify-content-center gap-2 flex-grow-1 mb-4"
                  style={{ height: "40px" }}
                >
                  {/* UPDATED: Use recordingProgress (0-100) for waveform and recordingTimeLeft for countdown */}
                  <MicWaveform
                    progressValue={recordingProgress}
                    mockColor={"#0081A4"}
                    time={isRecording ? recordingTimeLeft : -1}
                  />
                </div>
              </div>
              <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
            </div>
          </div>}
          <Col xs={12}>
            {!props.resultMode && props.data && soundStatus && secondCount === 0 && (
            isIOSDevice() ? (
              <IOSAudioPlayer
                audioUrl={questionAudio}
                onPlaying={handleSongPlaying}
                // onLoading={loadingSound}
                onFinishedPlaying={handleSongFinishedPlaying}
                // onError={handleAudioError}
                volume={volume}
                playbackRate={playbackSpeed}
                soundKey={soundKey}
              />
              ):(
                <Sound
                url={questionAudio}
                playStatus={Sound.status.PLAYING}
                onFinishedPlaying={handleSongFinishedPlaying}
                onPlaying={handleSongPlaying}
                volume={volume}
                playbackRate={playbackSpeed}
                key={soundKey}
                soundManagerConfig={{ debugMode: false }}
              />
              )
            )}
          </Col>
          <Col xs={12}>
            {blobURL && !props.testMode && <audio src={blobURL} controls="controls" />}
          </Col>
        </div>
      </Col>
      <Col xs={12}><h5>{questionText}</h5></Col>
      {/* Beep sound - only plays once when recording starts */}
      {!isIOSDevice() && !props.resultMode && beepStatus && <Sound
        // url={s3base + "/ptedata/ptemedia/beep.mp3"}
        url={Beep}
        playStatus={Sound.status.PLAYING}
        onFinishedPlaying={handleBeepFinishedPlaying}
        onError={handleBeepFinishedPlaying}
      />}
    </>
  );
};

export default ShortQue;